import { render, staticRenderFns } from "./ModalResultCard.vue?vue&type=template&id=38ee5e33&scoped=true&"
import script from "./ModalResultCard.vue?vue&type=script&lang=ts&"
export * from "./ModalResultCard.vue?vue&type=script&lang=ts&"
import style0 from "./ModalResultCard.vue?vue&type=style&index=0&id=38ee5e33&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ee5e33",
  null
  
)

export default component.exports